import { FC, lazy } from 'react';

const ExportRecipesDefaultView = lazy(() => import('./default-view/ExportRecipesDefaultView'));

export const ExportRecipes: FC = () => <ExportRecipesDefaultView />;
